import { render, staticRenderFns } from "./CertifiedGuide.vue?vue&type=template&id=f025ab22"
import script from "./CertifiedGuide.vue?vue&type=script&lang=js"
export * from "./CertifiedGuide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports